import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmployeeOvertimeHoursDTO  {
    _originalTypeClassName = "zERP.BO.EmployeeOvertimeHoursDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmployeeOvertimeHoursDTO.translate = translateService;
}
this.MonthHours = null;
this.YearHours = null;
this.ApprovedHours = null;
this.PendingHours = null;
this.EmployeeOvertimeHoursDTOKey = null;
this._key = this.EmployeeOvertimeHoursDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
MonthHours:any;
YearHours:any;
ApprovedHours:any;
PendingHours:any;
private _EmployeeOvertimeHoursDTOKey:any;
get EmployeeOvertimeHoursDTOKey(): any {
    return this._EmployeeOvertimeHoursDTOKey;
  }
set EmployeeOvertimeHoursDTOKey(value: any) {
    this._EmployeeOvertimeHoursDTOKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.EmployeeOvertimeHoursDTOKey == null || $this.EmployeeOvertimeHoursDTOKey == 0;
            }


}